import {Table} from 'antd';
import {Link} from 'react-router';
import {fixedToDisplayUnit} from "../../util/unitutils";
import {UnitType} from "../../api/Constants";

export const BasicTrimTable = ({trim, refresh, onRefresh, onApiFail, props}) => {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record) => {
                const {name, productId} = record;
                return <Link to={`/product/${productId}`}>{name}</Link>
            }
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record) => {
                const displayQuantity = fixedToDisplayUnit(val, UnitType.Gram);
                return `${displayQuantity} ${UnitType.Label[UnitType.Gram]}`;
            }
        },
        {
            title: 'Inventory',
            dataIndex: 'inventoryId',
            key: 'inventory',
            render: (val, record) => {
                const inventoryId = val;
                if (val === null) {
                    return `No entry`
                } else {
                    return <Link to={`/inventory/${inventoryId}`}>Inventory</Link>
                }
            }
        }
    ];

    return <Table columns={columns} dataSource={trim} pagination={false} />
}